import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import {
  catchError,
  distinctUntilChanged,
  map,
  switchMap
} from 'rxjs/operators';
import { PartnersPromotionsRequest } from '../../models/partners-promotions.interfaces';
import { PersonalizationEngineService } from '../../services/personalization-engine.service';
import { PartnersPromotionsService } from '../../services/promotions.service';
import * as PartnersActions from '../actions/partners.actions';
import { StateFacade as PartnersFacade } from '../facades/state.facade';

@Injectable()
export class PartnersEffects {
  loadPartnersPromotionsData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PartnersActions.loadPartnersPromotions),
      switchMap(() => {
        const request: PartnersPromotionsRequest = {
          carrierCode: 'DL'
        };
        return this.promotion.getPartnersPromotionsContent(request).pipe(
          map((content) => {
            return PartnersActions.loadPartnersPromotionsDataSuccess({
              partnersPromotions: {
                id: 'partners-promotions-content',
                partnersPromotionsContent: content
              }
            });
          })
        );
      }),
      catchError(() =>
        of(
          PartnersActions.loadPartnersPromotionsDataFailure({
            error: {
              id: 'partners-content-error',
              partnersContentError: 'partners'
            }
          })
        )
      )
    )
  );

  loadPartnersData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PartnersActions.loadPartners),
      switchMap(() => {
        return this.partnersFacade.partnersRequest$.pipe(
          distinctUntilChanged(
            (previous, current) =>
              JSON.stringify(previous) === JSON.stringify(current)
          ),
          switchMap((requestData) => {
            return this.partners.getPartnersContent(requestData).pipe(
              map((content) => {
                return PartnersActions.loadPartnersDataSuccess({
                  partners: { id: 'partners-content', partnersContent: content }
                });
              })
            );
          })
        );
      }),
      catchError(() =>
        of(
          PartnersActions.loadPartnersDataFailure({
            error: {
              id: 'partners-content-error',
              partnersContentError: 'partners'
            }
          })
        )
      )
    )
  );

  loadErrorMessages$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PartnersActions.loadAEMErrorMessages),
      switchMap(() =>
        this.promotion.getErrorMessages().pipe(
          map((content) =>
            PartnersActions.loadAEMErrorMessagesSuccess({
              aemErrorMessages: {
                id: 'aem-error-messages',
                errorMessagesContent: content.errorMessagesSection.errormessages
              }
            })
          ),
          catchError(() =>
            of(
              PartnersActions.loadAEMErrorMessagesFailure({
                aemErrorMessagesError: {
                  id: 'aem-error-messages-error',
                  aemErrorMessagesError: 'full-page'
                }
              })
            )
          )
        )
      )
    )
  );

  constructor(
    private readonly partners: PersonalizationEngineService,
    private readonly promotion: PartnersPromotionsService,
    private readonly actions$: Actions,
    private readonly partnersFacade: PartnersFacade
  ) {}
}
